export function isFilterColumn(field, isStatGrid, filterColumns) {
  if (Array.isArray(filterColumns)) return filterColumns.includes(field.code);

  if (field.filter || field.area === "filter") return true;

  if (isStatGrid) return field.source === "periodicity" || field.source === "organization";

  return field.code === "data_registry_np_fp_grid_data_origin";
}